import { api } from '../utils/request'

export const busBooking = async (data) => {
    const resp = await api({
        endpoint: '/busBooking',
        method: 'POST',
        data,
    })
    return resp
}